import { QChange } from "./QChange";
import { QObjDBFieldValue } from "./QObjDBFieldValue";
import { Globals } from "./Globals";
import { enumCalcCode, kEmployeePositionID } from "../constants";

export class QSerialObjDBObject {
  constructor() {
    this.fPairList = null;
    this.fSourceObj = null;
    this.fPersist = null;

    this.fObjID = null;
    this.fParentID = null;
    this.fChildIDList = null;

    this.fChildIndex = null;
    //  this.fTagAlong = null;
  }

  Init(dbObj, captureHierarchy) {
    this.fSourceObj = dbObj;
    var oID = dbObj.GetObjectID();
    this.fObjID = oID;

    this.fPairList = [];
    var n = dbObj.GetFieldCount();
    for (var i = 0; i < n; i++) {
      var fDef = dbObj.GetIndexFieldDef(i);

      if (fDef.IsSerializable(true)) {
        var fVal = dbObj.GetFieldValue(fDef);
        this.AddPair(fDef, fVal);
      }
    }

    this.fPersist = this.fSourceObj.fPersist;

    if (captureHierarchy) {
      // console.log("Capture Hierarchy:", oID);

      var childIndex = 0;
      var parent = dbObj.GetParent();
      if (parent) {
        childIndex = parent.IndexOfChild(dbObj);
        this.fParentID = parent.GetObjectID();
      }
      this.fChildIndex = childIndex;

      // console.log("ParentID:",this.fParentID);

      // OCN5-6486: walk fChildren directly, skipping null slots, so undo doesn't push nulls.
      var allChildren = dbObj.fChildren;
      if (allChildren && allChildren.length > 0) {
        this.fChildIDList = [];
        for (var i = 0; i < allChildren.length; i++) {
          if (allChildren[i] != null) this.fChildIDList.push(allChildren[i].GetObjectID());
        }
      }
    }

    if (dbObj.fHolderList) this.fHolderIDList = dbObj.fHolderList.map(h => h.GetObjectID());

    if (dbObj.fChanges) this.fChanges = this.CloneChanges();

    this.SetFilterState(dbObj);
  }

  CloneChanges() {
    var s = this.fSourceObj;
    var changes = null;
    if (s.fChanges.length === 1) {
      var c = s.fChanges[0];
      var newChange = c.Clone();
      var serialChange = newChange.Serialize();
      changes = [{ ...serialChange }];
    }
    return changes;
  }

  RestoreChanges(sourceDBObj) {
    var wsMgr = Globals._wsMgr;
    var doc = wsMgr.GetDoc();
    var jsonChange = JSON.parse(JSON.stringify(this.fChanges[0]));
    var dbChange = sourceDBObj.fChanges[0];

    var loadedChange = new QChange();
    loadedChange.InitChange(
      wsMgr,
      jsonChange,
      sourceDBObj,
      dbChange.fDBObj,
      doc.GetOverrideClass()
    );

    sourceDBObj.fChanges = [loadedChange];
  }

  Clone() {
    var c = new QSerialObjDBObject();
    c.fObjID = this.fObjID;
    c.fSourceObj = this.fSourceObj;
    c.fPersist = this.fPersist;
    c.fParentID = this.fParentID;
    c.fChildIndex = this.fChildIndex;
    if (this.fChildIDList) c.fChildIDList = this.fChildIDList.slice(0);
    if (this.fChanges) c.fChanges = this.CloneChanges();
    if (this.fHolderIDList) c.fHolderIDList = [...this.fHolderIDList];
    c.fIsDeleted = this.fIsDeleted;
    c.fFiltered = this.fFiltered;
    c.fPairList = new Array();

    const pairList = this.fPairList;

    pairList.forEach(pair => c.AddPair(pair.GetFieldDef(), pair.GetValue()));

    return c;
  }

  GetChildIndex() {
    return this.fChildIndex;
  }

  GetObjectID() {
    return this.fObjID;
  }

  GetSourceObj() {
    return this.fSourceObj;
  }

  FindPairValue(fieldDef) {
    var n = this.fPairList.length;
    for (var i = 0; i < n; i++) {
      var pair = this.fPairList[i];
      var fDef = pair.GetFieldDef();
      if (fDef == fieldDef) return pair.GetValue();
    }

    return "";
  }

  AddPair(fieldDef, value) {
    var v = new QObjDBFieldValue();
    v.InitFieldValue(fieldDef);
    v.SetValue(value);
    this.fPairList.push(v);
  }

  GetParentID(restoreHierarchy) {
    return this.fParentID;
  }

  RestoreTo(sourceObj) {
    this.fPairList.forEach(pair => {
      const fDef = pair.GetFieldDef();
      if (fDef.IsSerializable(false)) {
        const v = pair.GetValue();
        sourceObj.SetFieldValue(fDef, v);
      }
    });
  }

  RemoveFieldReferences(fieldDefList) {
    var newPairs = new Array();
    var n = this.fPairList.length;
    for (var i = 0; i < n; i++) {
      var pair = this.fPairList[i];
      var fDef = pair.GetFieldDef();
      var index = fieldDefList.indexOf(fDef);
      if (index == -1) newPairs.push(pair);
    }

    this.fPairList = newPairs;
  }

  SetFilterState(s) {
    this.fIsDeleted = s.fIsDeleted === true;
    this.fFiltered = s.fFiltered === true;
    this.fMuted = s.fMuted === true;
  }

  RestoreFilterState(s) {
    var oClass = s.fParentClass;
    s.fIsDeleted = this.fIsDeleted;
    s.fFiltered = this.fFiltered;
    s.fMuted = this.fMuted;
  }

  Restore(restoreHierarchy) {
    var s = this.fSourceObj;
    const doc = Globals._wsMgr.GetDoc();
    s.SetPersistent(this.fPersist);
    this.RestoreTo(s);
    if (this.fChanges) {
      this.RestoreChanges(s);
    }
    if (this.fHolderIDList) {
      const holderClass = doc.GetObjDB?.()?.GetClassByName?.("Box");
      if (holderClass) {
        s.SetHolderList(
          this.fHolderIDList.map(id => holderClass.RetrieveObject(id)).filter(Boolean)
        );
      }
    }
    if (doc.IsPositionDocument() && s.IsHolderObj()) {
      s.LoadParentPosition();
    }
    if (restoreHierarchy) {
      var oClass = s.fParentClass;

      // Set the parent
      if (this.fParentID != null) {
        var pObject = oClass.RetrieveObject(this.fParentID);
        s.fParent = pObject;
      } else s.fParent = null;

      s.fChildren = new Array();
      if (this.fChildIDList) {
        // Attach children
        var n = this.fChildIDList.length;
        for (var i = 0; i < n; i++) {
          var anID = this.fChildIDList[i];
          var cObject = oClass.RetrieveObject(anID);
          s.fChildren.push(cObject);
          cObject.fParent = s;
        }
      }
    }
  }
}
